export class UserConfig {
    dashboardList: number[] = [];
    theme: string = "light";
    language: string = "";
    dateFormat: string = "YYYY-MM-DD";
    timeFormat: string = "ampm";
    lockedMenu: boolean = true;
    timezone: string = "UTC";

    fillFromJson(data: any) {
        if (data.DashboardList) this.dashboardList = data.DashboardList;
        if (data.Theme) this.theme = data.Theme;
        if (data.LockedMenu != null && data.LockedMenu != undefined) this.lockedMenu = data.LockedMenu;
        if (data.Language) this.language = data.Language;
        if (data.DateFormat) this.dateFormat = data.DateFormat;
        if (data.TimeFormat) this.timeFormat = data.TimeFormat;
        if (data.Timezone) this.timezone = data.Timezone;
    }

    clone(): UserConfig {
        let res = new UserConfig();
        res.dashboardList = [...this.dashboardList];
        res.theme = this.theme;
        res.lockedMenu = this.lockedMenu;
        res.language = this.language;
        res.dateFormat = this.dateFormat;
        res.timeFormat = this.timeFormat;
        res.timezone = this.timezone;

        return res;
    }
}
